// extracted by mini-css-extract-plugin
module.exports = {"desktop":"pyramid_desktop__w89Ns","mobile":"pyramid_mobile__cAvdn","test":"pyramid_test__V5A_R"};